export enum EQualityIndex {
  NONE = 'NONE',
  BEST = 'BEST',
  CHEAPEST = 'CHEAPEST',
  FASTEST = 'FASTEST',
}
